<template>
	<div class="px-6 py-4 cursor-pointer hover:bg-grey-100 transition-colors">
		<div class="text-center">
			<div class="text-lg font-medium text-grey-700 mb-1">
				Click here to start planning a path
			</div>
			<div class="text-sm text-grey-500">
				Plan autonomous tillage paths for your fields
			</div>
		</div>
	</div>
</template>
